import styled from 'styled-components';

const StyledColoredTag = styled.span`
  border-radius: ${(props) => props.$radius ?? '4px'};
  padding: ${(props) => props.$padding ?? '6px'};
  font-weight: 600;
  font-size: ${(props) => props.$fontSize ?? '14px'};
  font-family: ${({ theme }) => theme?.fontFamily ?? 'inherit'};
  margin: 0 ${(props) => props.$marginX ?? '10px'};
  display: inline-block;
  align-items: center;
  ${(props) => {
    return `
      color: ${props.theme[props.variant] || props.theme.primary};
      background-color: ${props.theme[props.variant] || props.theme.primary}1f;
    `;
  }}
`;
export default StyledColoredTag;
